var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeLocationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16.5,
    viewBox: "0 0 17 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9971",
    "data-name": "Group 9971",
    transform: "translate(21831.5 2380.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1832",
    "data-name": "Ellipse 1832",
    className: "cls-1",
    cx: 1.257,
    cy: 1.257,
    r: 1.257,
    transform: "translate(-21824.143 -2366.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7386",
    "data-name": "Path 7386",
    className: "cls-2",
    d: "M26.905,17.71h-5",
    transform: "translate(-21847.406 -2395.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7389",
    "data-name": "Path 7389",
    className: "cls-3",
    d: "M15.644,26V21.916a2.5,2.5,0,0,0-5,0V26",
    transform: "translate(-21836.145 -2391.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7385",
    "data-name": "Path 7385",
    className: "cls-3",
    d: "M10.8,24.357H5.285V13.127a1.169,1.169,0,0,1,1.1-1.223H7.963V10.72a1.168,1.168,0,0,1,1.1-1.22h8.442a1.168,1.168,0,0,1,1.1,1.22v1.188h1.578a1.168,1.168,0,0,1,1.1,1.22V24.357H15.838",
    transform: "translate(-21836.285 -2389.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7390",
    "data-name": "Path 7390",
    className: "cls-2",
    d: "M-21805.873-2365.5v12.177",
    transform: "translate(-11.808 -12.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7391",
    "data-name": "Path 7391",
    className: "cls-2",
    d: "M-21806.117-2365.547v12.177",
    transform: "translate(-22.194 -11.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7392",
    "data-name": "Path 7392",
    className: "cls-2",
    d: "M26.905,17.71h-5",
    transform: "translate(-21847.406 -2393.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7393",
    "data-name": "Path 7393",
    className: "cls-2",
    d: "M26.905,17.71h-5",
    transform: "translate(-21847.406 -2391.791)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeLocationWhite);
export default __webpack_public_path__ + "static/media/OfficeLocationWhite.e4200fd7738f04a20f4fc5f5bb629538.svg";
export { ForwardRef as ReactComponent };